import { motion } from "framer-motion";
import {
  Target, TrendingUp, CalendarClock, Package, ShoppingCart, Factory,
  ClipboardCheck, Wrench, Cog, Timer, Users, CalendarCheck, Calculator, PieChart, Boxes,
} from "lucide-react";
import { ChapterHead } from "./motion";
import { MODULES } from "./data";

const ICONS = { Target, TrendingUp, CalendarClock, Package, ShoppingCart, Factory, ClipboardCheck, Wrench, Cog, Timer, Users, CalendarCheck, Calculator, PieChart, Boxes };

export const Modules = () => (
  <section data-testid="chapter-modules" className="chapter-print-break mx-auto max-w-7xl px-4 py-24 sm:px-6 sm:py-32 lg:px-8">
    <ChapterHead
      num="03"
      title="Scope of Work — Odoo Application Map"
      sub="One integrated suite covering the full Vision operating model — from tender capture through aftermarket service, including the complete HR suite and UAE WPS payroll."
    />
    <div className="grid gap-px overflow-hidden rounded-sm border border-line bg-line sm:grid-cols-2 lg:grid-cols-4">
      {MODULES.map((m, i) => {
        const Icon = ICONS[m.icon];
        return (
          <motion.div
            key={m.name}
            data-testid={`module-card-${i}`}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.55, delay: (i % 4) * 0.07, ease: [0.16, 1, 0.3, 1] }}
            className={`group relative bg-base p-7 transition-colors duration-300 hover:bg-hover ${
              i === MODULES.length - 1 && MODULES.length % 4 !== 0
                ? { 1: "lg:col-span-4", 2: "lg:col-span-3", 3: "lg:col-span-2" }[MODULES.length % 4]
                : ""
            }`}
          >
            <div className="flex items-start justify-between">
              <Icon className="h-6 w-6 text-amber-500 transition-transform duration-300 group-hover:-translate-y-1" />
              <span className="font-mono2 text-xs text-ink6">{String(i + 1).padStart(2, "0")}</span>
            </div>
            <h3 className="font-display mt-5 text-base font-semibold text-ink">{m.name}</h3>
            <p className="mt-3 text-[13px] leading-relaxed text-ink4">{m.desc}</p>
            <div className="absolute bottom-0 left-0 h-0.5 w-0 bg-amber-500 transition-[width] duration-500 group-hover:w-full" />
          </motion.div>
        );
      })}
    </div>
    <p className="mt-8 text-sm text-ink5">
      Delivered on Odoo Enterprise with certified country localizations (UAE FTA-ready, KSA ZATCA
      Fatoora, Egypt ETA), full Arabic UI & RTL, and Odoo Studio extensions for the rental contract
      model and procurement approval matrix.
    </p>
  </section>
);
